import { useState } from 'react';
import { categories, categoryFilter, feedItems } from '@/mocks/homeContent';
import type { FeedItem } from '@/mocks/homeContent';

function FeedCard({ item }: { item: FeedItem }) {
  return (
    <article className="flex flex-col gap-4 rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 hover:bg-background-100 md:p-5">
      <div className="flex items-center justify-between gap-2">
        <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
          <i className="ri-price-tag-3-line"></i>
          {item.category}
        </span>
        {item.hot && (
          <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-1 text-xs font-bold text-accent-900">
            <i className="ri-fire-line"></i> 热门
          </span>
        )}
      </div>

      <h3 className="text-base font-bold leading-snug text-foreground-950 md:text-lg">{item.title}</h3>
      <p className="line-clamp-2 text-sm leading-relaxed text-foreground-700">{item.excerpt}</p>

      <div className="mt-auto flex items-center justify-between gap-2 border-t border-background-200 pt-3">
        <div className="flex min-w-0 items-center gap-2">
          <img src={item.authorAvatar} alt={`${item.author}的头像`} className="h-8 w-8 rounded-full object-cover" />
          <div className="min-w-0">
            <p className="truncate text-xs font-semibold text-foreground-900">{item.author}</p>
            <p className="truncate text-xs text-foreground-600">{item.time} · {item.views}浏览</p>
          </div>
        </div>
        <div className="flex shrink-0 items-center gap-3 text-xs text-foreground-600">
          <span className="inline-flex items-center gap-1 whitespace-nowrap"><i className="ri-heart-3-line text-primary-500"></i>{item.likes}</span>
          <span className="inline-flex items-center gap-1 whitespace-nowrap"><i className="ri-chat-3-line"></i>{item.comments}</span>
        </div>
      </div>
    </article>
  );
}

export default function Feed() {
  const [active, setActive] = useState('全部');
  const list = active === '全部' ? feedItems : feedItems.filter((i) => i.category === active);

  return (
    <section id="feed" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-2">
          <span className="text-xs font-bold uppercase tracking-widest text-primary-600">Latest Posts</span>
          <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">最新投稿</h2>
          <p className="mt-1 max-w-2xl text-sm text-foreground-700">
            瓜友们正在分享的新鲜事，点击栏目筛选，看看今天大家最关心的话题。
          </p>
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-2 rounded-full border border-background-200 bg-background-100 p-1 md:w-fit">
          {categoryFilter.map((c) => (
            <button
              key={c}
              onClick={() => setActive(c)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-semibold transition-colors md:px-4 md:py-2 md:text-sm ${
                active === c ? 'bg-foreground-900 text-background-50' : 'text-foreground-700 hover:bg-background-50 hover:text-primary-700'
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((item) => (
            <FeedCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}